module.exports = __webpack_public_path__ + "img/韩美整形.de653f2.png";